import { get } from 'lodash';
import { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { SET_LOADING, SET_USER } from '../../actions/auth.actions';
import AuthService from '../services/auth';
import { useLocation } from 'react-router-dom';

const authService = AuthService();

const UserLogin = () => {
  const dispatch = useDispatch();
  const userId = useSelector(store => get(store, 'auth.user.id'));
  const userReady = useSelector(store => get(store, 'auth.userReady'));
  const location = useLocation();

  useEffect(() => {
    if (!userReady && userId) {
      dispatch({ type: SET_LOADING, payload: true });
      authService.getUser()
        .then((userData) => {
          if (userData) {
            dispatch({ type: SET_USER, payload: userData });
          }
          dispatch({ type: SET_LOADING, payload: false });
        }).catch(() => {
          dispatch({ type: SET_LOADING, payload: false });
        });
    }
  }, [userId, location.pathname]);

  return null;
};

export default UserLogin;

